module.exports = __webpack_public_path__ + "img/wxgongzhonghao.b6f1f566.png";